<script setup>
import {onMounted} from "vue";
import {useRoute} from "vue-router";
import {Api} from "@/service/api";


const route = useRoute()

onMounted(async() => {
    const query_info = {
        code: route.query.code,
        state: route.query.state,
        device_id: route.query.device_id,
    }

    await Api.VKOauthLogin(query_info)
})

</script>

<template>
    <div>
        12345
    </div>
</template>

<style scoped>

</style>